interface Props {
  className?: string
  strokeWidth?: string | number
}

export function EchoPanelCluster({ className }: Props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <circle cx="6" cy="6" r="1.6" fill="currentColor" />
      <circle cx="13" cy="6" r="1.6" fill="currentColor" />
      <circle cx="6" cy="13" r="1.6" fill="currentColor" />
      <circle cx="13" cy="13" r="1.6" fill="currentColor" />
      <circle cx="9.5" cy="19" r="1.6" fill="currentColor" />
    </svg>
  )
}
